export default __webpack_public_path__ + "static/media/mahligai.ae63a616.png";